import { useNavigate } from 'react-router-dom';
import s from './Purchases.module.scss';
import { ReactComponent as SmallStar } from 'images/new-icons/small-star.svg';
import { ReactComponent as RiyalIcon } from 'images/new-icons/riyal.svg';
import Button from 'components/shared/Button';
import vaucherImg from './voucher.png'
const PurchasesList = ({
  purchases,
  refundLoading,
  handleNext,
  setOrderId,
  setPrice,
  setProductName,
  setTryotoOrderId,
}) => {
  const navigate = useNavigate();

  return (
  <>
  {purchases?.map((item: any) => {
    const hasProduct = !!item.product;
    const hasGiftCard = !!item.gift_cards;
 
    if (!hasProduct && !hasGiftCard) return null;
    if (hasGiftCard) return null;

    const isGiftCard = hasGiftCard;
    const product = item.product;
    const giftCard = item.gift_cards;

    const name = hasProduct
      ? product.name
      : `Gift Card for  ${giftCard?.denomination} SAR`;

    const description = hasProduct
      ? product.description
      : `Valid until ${giftCard?.valid_until}`;

    const image = hasProduct
      ? product.image
      : vaucherImg;  
    const price = hasProduct ? product.price : giftCard?.denomination;

    const status = item?.status || item?.orders?.status;

    return (
      <div
        key={item.id}
        className={s.purchases_card}
        onClick={() => {
          if (status === 'Refund In Progress') {
            navigate(`/return-status/${item?.order_id}`);
          } else if (hasProduct) {
            navigate(`/order/${item?.order_id}/${product?.id}`);
          }  
        }}
      >
        <div className={s.purchases_card_content}>
          <img className={s.purchases_card_image} src={image} alt={name} />
          <div className={s.purchases_card_info}>
            <div className={s.purchases_card_info_title}>
              {hasProduct ? product.name : (
                <>Gift Card for <RiyalIcon className={s.riyal_icon} /> {giftCard?.denomination}</>
              )}
            </div>
            <div className={s.purchases_card_info_subtitle}>{description}</div>
            <div className={s.purchases_card_info_footer}>
              <div className={s.purchases_card_info_footer_price}><RiyalIcon className={s.riyal_icon} /> {price}</div>
              <div
                className={s.purchases_card_info_footer_status}
                style={{
                  color:
                    status === 'Refunded'
                      ? '#C555B4'
                      : status === 'Completed'
                      ? '#367F9A'
                      : status === 'Refund In Progress'
                      ? '#F19E6E'
                      : '',
                  backgroundColor:
                    status === 'Refunded'
                      ? '#C555B426'
                      : status === 'Completed'
                      ? '#367F9A26'
                      : status === 'Refund In Progress'
                      ? '#F19E6E26'
                      : '',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (status === 'Completed') {
                    if (hasProduct) {
                      navigate(`/order/${item?.order_id}/${product?.id}`);
                    }  
                  }
                }}
              >
                {status === 'Refunded' ? (
                  'Refunded'
                ) : status === 'Completed' ? (
                  hasGiftCard ? 'Completed' : 'Leave your review'
                ) : status === 'Refund In Progress' ? (
                  'Refund in progress'
                ) : (
                  <div className={s.rating}>
                    <SmallStar />
                    <div>5</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {status === 'Completed' && hasProduct && (
          <Button
            wide
            ligtGrey
            onClick={(e) => {
              e.stopPropagation();
              setOrderId(item?.order_id);
              setPrice(product?.price);
              setProductName(product?.name);
              setTryotoOrderId(item?.order_id);
              handleNext();
            }}
            loading={refundLoading}
            disabled={refundLoading}
          >
            Get a refund
          </Button>
        )}

        {status === 'Refund In Progress' && (
          <Button
            wide
            ligtGrey
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/return-status/${item?.order_id}`);
            }}
          >
            Check status
          </Button>
        )}
      </div>
    );
  })}
</>
  );
};

export default PurchasesList;
